import React from 'react'
import { isEmpty } from 'lodash'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import downArrow from '../../../../assets/icons/arrow-down.svg'

const SortByFilterSelect = props => {
	const {
		hotelLabels,
		sortByEvent,
		sortByMenuEvent,
		sortByMenuVisible,
		sortByValue
	} = props

	let roomSortOptions = [
		{
			label: hotelLabels.sortByDefaultLabel ? hotelLabels.sortByDefaultLabel : 'Any',
			value: ''
		},
		{
			label: hotelLabels.reccomended ? hotelLabels.reccomended : 'Recommended',
			value: 'cms'
		},
		{
			label: hotelLabels.priceHighToLow ? hotelLabels.priceHighToLow : 'Price High to Low',
			value: 'high'
		},
		{
			label: hotelLabels.priceLowToHigh ? hotelLabels.priceLowToHigh : 'Price Low to High',
			value: 'low'
		}
	]

	let activeSortByLabel = null

	roomSortOptions.forEach(option => {
		if (String(option.value) === String(sortByValue)) {
			activeSortByLabel = option.label
		}
	})

	let renderRoomSortOptions = []

	for (let sortKey in roomSortOptions) {
		let currentOption = roomSortOptions[sortKey]

		if (currentOption.label){
			renderRoomSortOptions.push(
				<button
					className="btn btn-transparent"
					key={ currentOption.label }
					value={ currentOption.value }
					onClick={() => sortByEvent(currentOption.value)}
				>
					{ currentOption.label }
				</button>
			)
		}
	}

	return !isEmpty(renderRoomSortOptions) ? (
		<div
			className="bk-flow-room__filter sort-by"
			onClick={() => sortByMenuEvent()}
			tabIndex={0}
		>
			<div className="bk-flow-room__filter-input">
				<p className="label">
					{ hotelLabels.sortBy ? hotelLabels.sortBy : 'Sort By'}:
				</p>
				<p className="value">
					{activeSortByLabel}
				</p>
				<img
					className="arrow"
					src={downArrow}
					alt={ hotelLabels.sortBy ? hotelLabels.sortBy : 'Sort By'}
				/>
			</div>

			{sortByMenuVisible &&
				<ClickAwayListener onClickAway={ sortByMenuEvent }>
					<div className="bk-flow-room__filter-dropdown">
						{renderRoomSortOptions}
					</div>
				</ClickAwayListener>
			}
		</div>
	) : null
}

export default SortByFilterSelect



// WEBPACK FOOTER //
// ./src/components/forms/filtersForm/elements/SortByFilterSelect.js